// AWS Batch のジョブ名規則 (^[A-Za-z0-9][A-Za-z0-9_-]{0,127}$, 最大128文字) に対し、
// API 側で job_name = `${study_name}-${YYYYMMDD}-autocfd` 等のサフィックスが付くため、
// study_name は 1〜100 文字に制限する（api/input/utils/validation.py と一致させること）。
export const STUDY_NAME_PATTERN = /^[A-Za-z0-9][A-Za-z0-9_-]{0,99}$/;

export const STUDY_NAME_ERROR =
  'study name は半角英数字・ハイフン(-)・アンダースコア(_) のみ、先頭は英数字、100文字以内で入力して下さい。';

// study_name が AWS Batch ジョブ名に使える形式かを判定する
export const isValidStudyName = (name: string): boolean =>
  typeof name === 'string' && STUDY_NAME_PATTERN.test(name);
